export enum EmailNotificationType {
  'questionnaire' = 'questionnaire',
  'intake-form' = 'intake-form'
}

export type EmailNotificationsConfig = {
  [key in EmailNotificationType]: {
    enabled: boolean;
    notificationRecipients: string[]; // array of emails
  };
};

export const emailNotificationTypeToFriendlyNameMap: { [key in EmailNotificationType]: string } = {
  [EmailNotificationType.questionnaire]: 'Questionnaire',
  [EmailNotificationType['intake-form']]: 'Intake Form'
};

export const emailNotificationTypeToInfoPopoverMap: { [key in EmailNotificationType]: string } = {
  [EmailNotificationType.questionnaire]:
    'When a patient submits a questionnaire, the system automatically sends an email notification to the designated recipients',
  [EmailNotificationType['intake-form']]:
    'When a patient submits an intake form, the system automatically sends an email notification to the designated recipients'
};
